"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Steps = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = require("classnames");
var react_1 = require("react");
var buttons_1 = require("../buttons");
var Step_1 = require("./Step");
var Steps = function (_a) {
    var testId = _a["data-testid"], steps = _a.steps, current = _a.current, className = _a.className, onBack = _a.onBack, onClick = _a.onClick, _b = _a.backText, backText = _b === void 0 ? 'Back' : _b;
    var currentStep = (0, react_1.useMemo)(function () {
        if (current) {
            var step = steps.find(function (s) { return s.name === current; });
            return step || steps[0];
        }
        return steps[0];
    }, [current]);
    var stepsWithState = (0, react_1.useMemo)(function () {
        if (current) {
            var index_1 = steps.findIndex(function (s) { return s.name === current; });
            index_1 = index_1 < 0 ? 0 : index_1;
            return steps.map(function (s, i) {
                var state = s.state;
                if (!state) {
                    state =
                        index_1 === i ? 'current' : i < index_1 ? 'completed' : 'upcoming';
                }
                return __assign(__assign({}, s), { state: state });
            });
        }
        return steps;
    }, [steps, current]);
    return ((0, jsx_runtime_1.jsxs)("aside", __assign({ role: "complementary", "aria-label": "Wizard Steps", className: (0, classnames_1.default)('squid-hidden', 'lg:squid-block', 'squid-mr-8', 'squid-min-w-max', className) }, { children: [onBack && ((0, jsx_runtime_1.jsx)(buttons_1.Button, __assign({ leftIcon: "ArrowLeft", variant: "text", onClick: onBack, className: "squid-mb-4", "data-testid": "".concat(testId, "BackBtn"), "aria-label": backText }, { children: backText }))), (0, jsx_runtime_1.jsx)("div", __assign({ className: (0, classnames_1.default)('squid-flex squid-flex-col') }, { children: stepsWithState.map(function (step, index) {
                    var state = currentStep.name === step.name ? 'current' : step.state;
                    var previousSteps = __spreadArray([], steps, true).slice(0, index);
                    var clickable = onClick &&
                        (['completed', 'skipped'].includes(state) ||
                            previousSteps.every(function (s) {
                                return ['completed', 'skipped'].includes(s.state);
                            }));
                    return ((0, jsx_runtime_1.jsx)(Step_1.Step, { testId: testId, step: __assign(__assign({}, step), { state: state !== null && state !== void 0 ? state : 'upcoming' }), index: index, totalSteps: steps.length, onClick: onClick, clickable: clickable }, step.name));
                }) }))] })));
};
exports.Steps = Steps;
